export const showInputTextMaxLength = (text: number) => {
  return text + '文字以内で入力して下さい';
};

export const showInputTextMinLength = (text: number) => {
  return text + '文字以上で入力して下さい';
};
